/**
 * ????? ????API ???? ????.
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js????????????????? ???????? Authorization ???????????????.
 *
 * ????? ???: axios ??????????????? 401 ?????? ????, ?????????????????? ???.
 */
import api from './index'

/* ================================================================
 * ????? API
 * ================================================================ */

/**
 * ????? ?? ???? (??????????+ ?????????).
 * category LEFT JOIN???? ?????????? ???? ??????????.
 *
 * @param {Object} params - { keyword, categoryCode, viewYn, page, size }
 * @returns {Promise} { data: { items, total, page, size, totalPages }, code, message }
 */
export function getProductList(params) {
  return api.get('/api/v1/product', { params })
}

export function getProductAccountList(params) {
  return api.get('/api/v1/product/accounts', { params })
}

export function createProductAccount(data) {
  return api.post('/api/v1/product/accounts', data)
}

export function updateProductAccount(branchAccountCode, data) {
  return api.put(`/api/v1/product/accounts/${branchAccountCode}`, data)
}

export function updateProductAccountActive(branchAccountCode, activeYn) {
  return api.patch(`/api/v1/product/accounts/${branchAccountCode}/active`, null, { params: { activeYn } })
}

export function getShippingFeePolicies(params) {
  return api.get('/api/v1/shipping-fees/policies', { params })
}

export function createShippingFeePolicy(data) {
  return api.post('/api/v1/shipping-fees/policies', data)
}

export function updateShippingFeePolicy(shippingFeePolicyCode, data) {
  return api.put(`/api/v1/shipping-fees/policies/${shippingFeePolicyCode}`, data)
}

export function getShippingRemoteAreas(params) {
  return api.get('/api/v1/shipping-fees/remote-areas', { params })
}

export function createShippingRemoteArea(data) {
  return api.post('/api/v1/shipping-fees/remote-areas', data)
}

export function updateShippingRemoteArea(shippingRemoteAreaZipCode, data) {
  return api.put(`/api/v1/shipping-fees/remote-areas/${shippingRemoteAreaZipCode}`, data)
}

/**
 * ????? ????? ????.
 * productText(?????????)???????????? ???????????????.
 *
 * @param {string} productCode - ??????????
 * @returns {Promise} { productCode, categoryCode, categoryName, productName, productText, viewYn, ... }
 */
/** 공급사 목록 - [{ sellerCode, sellerName }] */
export function getSellerList() {
  return api.get('/api/v1/product/sellers')
}

/** 선택한 상품들의 공급사 일괄 변경(본사) - { productCodes, sellerCode } */
export function updateProductSellers(data) {
  return api.put('/api/v1/product/bulk/seller', data)
}

export function getProductDetail(productCode) {
  return api.get(`/api/v1/product/${productCode}`)
}

/**
 * ????? ??? (HQ ?????? ?????).
 *
 * @param {Object} data - { productName, categoryCode, productText }
 * @returns {Promise} ?????????? ????? ?????
 */
export function createProduct(data) {
  return api.post('/api/v1/product', data)
}

/**
 * ????? ??? ???? (HQ ?????? ?????).
 *
 * @param {string} productCode - ????????????????
 * @param {Object} data - { productName, categoryCode, productText }
 * @returns {Promise} ??????????? ????? ?????
 */
export function updateProduct(productCode, data) {
  return api.put(`/api/v1/product/${productCode}`, data)
}

export function registerCurrentBranchProduct(productCode, data) {
  return api.post(`/api/v1/product/${productCode}/branch-products/current`, data)
}

/**
 * ????? ???????? ???? (HQ ?????? ?????).
 * view_yn 'Y' ??'N' ????? 'N' ??'Y' ??????? ?????????.
 *
 * @param {string} productCode - ????????????????
 * @returns {Promise} ????? ????? ????? ?????
 */
export function toggleProductView(productCode) {
  return api.post(`/api/v1/product/${productCode}/view`)
}

/**
 * ????? ???? (HQ ?????? ?????, soft delete).
 *
 * @param {string} productCode - ????????????????
 * @returns {Promise} { code, message }
 */
export function deleteProduct(productCode) {
  return api.delete(`/api/v1/product/${productCode}`)
}

/**
 * ????? ?????? ??????(HQ ?????? ?????).
 *
 * @param {string} productCode - ??????????
 * @param {string} fileType - thumbnail | detail
 * @param {File} file - ????????? ?????? ???
 * @returns {Promise} ProductDetailResponse
 */
export function uploadProductImage(productCode, fileType, file) {
  const formData = new FormData()
  formData.append('fileType', fileType)
  formData.append('file', file)
  return api.post(`/api/v1/product/${productCode}/images`, formData, {
    timeout: 60000,
    transformRequest: [(data, headers) => {
      if (data instanceof FormData && headers?.['Content-Type']) {
        delete headers['Content-Type']
      }
      return data
    }],
  })
}

/**
 * ????? ?????? ???? (HQ ?????? ?????).
 *
 * @param {string} productCode - ??????????
 * @param {string} seq - product_media.product_media_code
 * @returns {Promise} ProductDetailResponse
 */
export function deleteProductImage(productCode, seq) {
  return api.delete(`/api/v1/product/${productCode}/images/${seq}`)
}
